<template>
  <div :class="['axiome-logique-container', 'axiome-logique-some-value-from']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        :isInLogicalAxiom="true" />
      <template v-if="onPropertyBlanknodes.length">
        <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>


    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">some</span>
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="someValuesFromLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        :isInLogicalAxiom="true" />
      <AttributeBlankNode :blankNodes="someValuesFromBlanknodes" :braceDisplay="true" :leftMargin="false"
        :showLanguageBadge="showLanguageBadge"
        :showFirstOperand="someValuesFromLiterals !== undefined && someValuesFromLiterals.length > 0" />
    </div>

  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeSomeValuesFrom",
  computed: {
    someValuesFromLiterals() {
      let result = [];
      this.someValuesFrom.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    someValuesFromBlanknodes() {
      let blankNodes = [];
      this.someValuesFrom.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    onProperty: {
      type: Array,
      default: () => []
    },
    someValuesFrom: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>